export const addLoadingIcon = () => {
  const loading = document.getElementById('loading');
  if (loading === null) return;
  loading.classList.remove('search__load_hide');
};

export const hideLoadingIcon = () => {
  const loading = document.getElementById('loading');
  if (loading === null) return;
  loading.classList.add('search__load_hide');
};

export const getSeason = (month) => {
  let season;
  if (month === 11 || month <= 1) {
    season = 'winter';
  } else if (month >= 2 && month <= 4) {
    season = 'spring';
  } else if (month >= 5 && month <= 7) {
    season = 'summer';
  } else if (month >= 8 || month <= 10) {
    season = 'autumn';
  }
  return season;
};

export const getTimesOfDay = (hour) => {
  let timesOfday;
  if (hour === 0 || hour <= 5) {
    timesOfday = 'night';
  } else if (hour >= 6 && hour <= 11) {
    timesOfday = 'morning';
  } else if (hour >= 12 && hour <= 17) {
    timesOfday = 'afternoon';
  } else if (hour >= 18 || hour <= 23) {
    timesOfday = 'evening';
  }
  return timesOfday;
};

export const convertDDToDMS = (deg, lng) => {
  let d = parseInt(deg);
  const minfloat = Math.abs((deg - d) * 60);
  let m = Math.floor(minfloat);
  const secfloat = (minfloat - m) * 60;
  let s = Math.round(secfloat);
  d = Math.abs(d);

  if (s === 60) {
    m += 1;
    s = 0;
  }
  if (m === 60) {
    d += 1;
    m = 0;
  }

  const dir = deg < 0 ? (lng ? 'W' : 'S') : lng ? 'E' : 'N';

  return `${d}°${m}' ${dir}`;
};

export const translate = (langDoc) => {
  const elementToTranslate = document.querySelectorAll('[data-i18n]');

  elementToTranslate.forEach((element) => {
    const path = element.dataset.i18n.split('.');
    let res = langDoc;

    path.forEach((piece) => {
      res = res[piece];
    });

    element.textContent = res;
  });
};
